import { render } from "./EmoticonPlusOutline.vue?vue&type=template&id=df882e4c"
import script from "./EmoticonPlusOutline.vue?vue&type=script&lang=js"
export * from "./EmoticonPlusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__